import * as React from "react";
import { I18n } from "@lingui/react";
import moment from "moment";
import {
  DataGridRow,
  DataGridCell,
  Main,
  Supportive,
} from "@conserveit/blocks";
import { parseId } from "./ListRow.utils";
import {
  getPriorityMap,
  getStatusMap,
  getResponsibleMap,
  getContextMap,
} from "../../../Action/utils/lists";

interface Props {
  isActive: boolean;
  onClick: () => void;
  id: string;
  summary: string;
  priority: string;
  context: string;
  status: string;
  createdAt: any;
  updatedAt: any;
  assignee: string;
  responsible: string;
  siteName: string;
  projectName: string;
  projectKey: string;
  isDisabled: boolean;
}

const ListRow: React.FC<Props> = ({
  id,
  summary,
  context,
  priority,
  status,
  updatedAt,
  responsible,
  siteName,
  projectName,
  projectKey,
  onClick,
  isActive,
}) => (
  <I18n>
    {({ i18n }) => (
      <DataGridRow selected={isActive} cursor="pointer" onClick={onClick}>
        <DataGridCell>
          <Main>{`#${parseId(id)}`}</Main>
        </DataGridCell>

        <DataGridCell>
          <Main>{getPriorityMap(i18n)[priority]}</Main>
        </DataGridCell>

        <DataGridCell>
          <Main>{siteName}</Main>
          <Supportive>{projectName}</Supportive>
        </DataGridCell>

        <DataGridCell>
          <Main>{summary}</Main>
        </DataGridCell>

        {/*
        TODO: Coming soon
        {activeColumns.EQUIPS && (
          <$Cell>N Equips</$Cell>
        */}

        <DataGridCell>
          <Main>{(context && getContextMap(i18n)[context]) || "–"}</Main>
        </DataGridCell>

        <DataGridCell>
          <Main>
            {(responsible &&
              getResponsibleMap(i18n, projectKey === "WOOL")[responsible]) ||
              "-"}
          </Main>
        </DataGridCell>

        <DataGridCell>
          <Main>{moment(updatedAt).local().fromNow()}</Main>
        </DataGridCell>

        <DataGridCell>
          <Main>{(status && getStatusMap(i18n)[status]) || "–"}</Main>
        </DataGridCell>
      </DataGridRow>
    )}
  </I18n>
);

export default React.memo(
  ListRow,
  (p, n) =>
    p.isActive === n.isActive &&
    p.updatedAt === n.updatedAt &&
    p.status === n.status &&
    p.responsible === n.responsible
);
